import React, { useState, useEffect } from 'react';
import { ArrowDown, ArrowUp, ChevronDown, ChevronUp } from 'react-feather';
import { Card, CardBody } from 'reactstrap';
import { numberFormater } from '../../helpers/common';

const SummaryCardCompact = (props) => {
    const tag = "CARD";
    const [percentage, setPercentage] = useState(0);
    useEffect(()=>{
        if(props.previous == null || props.previous == 0){
            setPercentage(0);
        }else{
            setPercentage((((props.current - props.previous)/props.previous)*100).toFixed(1))
        }
    }, [props])
    return (
        <Card className="w-100" style={{display: "inline-block", float: "none", /*maxWidth: "270px",*/ marginRight: "30px", minWidth: "150px"}}>
        {/* <Card className='mx-2 mb-3' style={{maxWidth: "250px", float: "left"}}> */}
            <CardBody>
                <h6 className='m-0 pb-2 secondary' style={{fontSize: "12px", fontWeight: "400"}}>
                    {props.title}
                    <span className={percentage < 0 ? "m-0 p-0 danger" : percentage == 0 ? "m-0 p-0 secondary" : "m-0 p-0 success"} style={{fontSize: "12px", float: "right"}}>
                        {
                            percentage < 0 && 
                            <ChevronDown style={{marginTop: "-3px"}} className="danger" size={16}/>
                        }
                        {
                            percentage > 0 && 
                            <ChevronUp style={{marginTop: "-3px"}} className="success" size={16}/>
                        }
                        <span>{props.previous == 0 ? "0%" : Math.abs(percentage)+"%"}</span>
                    </span>
                </h6>
                <h3 className='m-0 p-0 mb-2' style={{fontSize: "24px", fontWeight: "500"}}>{numberFormater(props.current)}</h3>
                <p className='m-0 p-0 secondary' style={{fontSize: "12px"}}>Previous {`  `} <span className='primary'>{numberFormater(props.previous)}</span></p>
            </CardBody>
        </Card>
    )
}

export default SummaryCardCompact;